import React, { useState } from 'react';
import { Container, Row, Col, Button, ListGroup, Offcanvas } from 'react-bootstrap';
import ProductCard from '../components/ProductCard';
import products from '../data/productData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight, faFilter } from '@fortawesome/free-solid-svg-icons';

const productData = products;

const FilterItem = ({ item, onFilter }) => (
  <Button
    variant="link"
    className="text-decoration-none text-start text-dark ps-0"
    onClick={() => onFilter(item)}
  >
    &gt; {item}
  </Button>
);

const ProductPage = () => {
  const [filteredProducts, setFilteredProducts] = useState(productData);
  const [showFilterOffcanvas, setShowFilterOffcanvas] = useState(false);

  const handleCloseFilterOffcanvas = () => setShowFilterOffcanvas(false);
  const handleShowFilterOffcanvas = () => setShowFilterOffcanvas(true);

  const handleFilter = (filterValue, isCategory = true) => {
    let newFilteredProducts;
    if (isCategory) {
      newFilteredProducts = filterValue === 'All'
        ? productData
        : productData.filter((product) => product.category === filterValue);
    } else {
      newFilteredProducts = productData.filter((product) =>
        product.title.toLowerCase().includes(filterValue.toLowerCase())
      );
    }
    setFilteredProducts(newFilteredProducts);
    handleCloseFilterOffcanvas();
  };

  const filterSection = (
    <div className="p-4">
      <ListGroup variant="flush" className='bg-tertiary p-0'>
        <ListGroup.Item action onClick={() => handleFilter('All')} className="d-flex p-0 align-items-center justify-content-start">
          <h1 className="mb-3">Categories</h1>
          <FontAwesomeIcon icon={faRotateRight} size="sm" className="ms-2"/>
        </ListGroup.Item>
        <hr className="my-2" />
        <ListGroup.Item>
          <div className="fw-bold">&gt; Pharmaceuticals for Pediatrics</div>
          <div className="ms-3">
            <FilterItem
              item="Antibiotic Powder Bottles"
              onFilter={(item) => handleFilter(item, false)}
            />
            <FilterItem
              item="Bronchodilator, Expectorant Syrup"
              onFilter={(item) => handleFilter(item, false)}
            />
            <FilterItem
              item="Corroborant, Supplements"
              onFilter={(item) => handleFilter(item, false)}
            />
            <FilterItem
              item="Digestive Medications"
              onFilter={(item) => handleFilter(item, false)}
            />
          </div>
        </ListGroup.Item>
        <ListGroup.Item>
          <div className="fw-bold">&gt; Medical Equipment</div>
          <div className="ms-3">
            <FilterItem
              item="Respiratory Function Test Device"
              onFilter={(item) => handleFilter(item, false)}
            />
            <FilterItem
              item="Testing Equipment and Machines for Laboratories"
              onFilter={(item) => handleFilter(item, false)}
            />
            <FilterItem
              item="Ophthalmic Instruments, Tools and Supplies"
              onFilter={(item) => handleFilter(item, false)}
            />
          </div>
        </ListGroup.Item>
        {/* Add other categories as ListGroup.Item and pass onCloseFilter */}
      </ListGroup>
    </div>
  );

  return (
    <Container fluid className="h-100">
      <Row className="h-100 d-flex">
        {/* Filter Section - Visible on md and larger */}
        <Col md={3} className="bg-tertiary pl-4 d-none d-md-block">
          {filterSection}
        </Col>

        {/* Hamburger Button for Filter - Visible on sm and xs */}
        <Col xs={12} className="bg-tertiary d-md-none p-2">
          <Button variant="outline-dark" onClick={handleShowFilterOffcanvas}>
            <FontAwesomeIcon icon={faFilter} className="me-2" /> Categories
          </Button>

          {/* Filter Offcanvas */}
          <Offcanvas show={showFilterOffcanvas} onHide={handleCloseFilterOffcanvas} placement="start" className="bg-tertiary">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Filter Products</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              {filterSection}
            </Offcanvas.Body>
          </Offcanvas>
        </Col>

        {/* Product Listing Section */}
        <Col md={9} className="p-4">
          <h1 className="mb-4">Products</h1>
          <hr className="my-2" />
          <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">
            {filteredProducts.map((product) => (
              <ProductCard key={product.id} {...product} />
            ))}
          </Row>
          {filteredProducts.length === 0 && (
            <div className="mt-3">No products match the current filter.</div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default ProductPage;